<template>
  <div>
    <h5 class="package-title">Componente circuit</h5>
    <b-card no-body class="border-top-0">
      <b-table-simple class="table table-sm mb-0" striped stacked="sm">
        <thead>
          <tr>
            <td><span class="ml-4">Nume</span></td>
            <td>Perioada</td>
            <td>Disponoibilitate</td>
            <td>Pret</td>
            <td>&nbsp;</td>
          </tr>
        </thead>
        <tbody>
          <template v-for="(el, elIndex) in date.elements">
            <Element
              :index="elIndex"
              :element="el"
              :currency="currency"
              :checked="selection[elIndex]"
              :pax="pax"
              @change="onElementSelectionChange($event, elIndex)"
              @toggleSeatMap="$emit('toggleSeatMap', { direction: $event.direction, element: elIndex })"
              :key="'el' + elIndex" />
          </template>
        </tbody>
      </b-table-simple>
    </b-card>
  </div>
</template>

<script>
import Element from './element.vue'
export default {
  props: {
    date: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    selection: {
      type: Array,
      required: true
    },
    pax: {
      type: Array,
      required: true
    }
  },
  components: {
    Element
  },
  methods: {
    onElementSelectionChange (value, index) {
      this.$emit('change', { value, index })
    }
  }
}
</script>
